export default __webpack_public_path__ + "ed5f64785df3fa7e71208a488881c8cc.png";